import { useRef, useState } from "react";
import { PayPalButtons } from "@paypal/react-paypal-js";
import { toast } from "sonner";
import { CreditCard } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { startCardCheckout, paypalCreateOrder, paypalCapture, paypalCancelled, cardError } from "@/lib/purchase";

// Card (Stripe) + PayPal for one product and one target (memory / year). Needs a PayPalScriptProvider above.
export const PayButtons = ({ payload, refundOk, paypalReady, paypalMode, cardEnabled = true, onPaid, cardLabel = "Pay with Card", testPrefix }) => {
  const [paying, setPaying] = useState(false);
  const full = { ...payload, refund_policy_accepted: refundOk };
  const agreed = useRef(refundOk);
  agreed.current = refundOk;

  const payCard = async () => {
    setPaying(true);
    try { await startCardCheckout(full); } catch (e) { setPaying(false); cardError(e); }
  };

  return (
    <div className="space-y-3">
      {cardEnabled && (
      <Button data-testid={`${testPrefix}-pay-card`} onClick={payCard} disabled={!refundOk || paying}
        className="w-full rounded-full bg-[#2C2A28] py-6 text-base font-semibold text-[#FDFBF7] hover:bg-[#3d3a37]">
        <CreditCard size={20} weight="duotone" className="mr-2" /> {paying ? "Opening secure checkout…" : cardLabel}
      </Button>
      )}
      {paypalReady && (
        <div data-testid={`${testPrefix}-paypal`} className={refundOk ? "" : "opacity-50"}>
          <PayPalButtons
            forceReRender={[JSON.stringify(payload)]}
            style={{ layout: "vertical", color: "gold", shape: "pill", label: "pay" }}
            onClick={(d, actions) => {
              if (agreed.current) return actions.resolve();
              toast.error("Please tick the Refund Policy box first.");
              return actions.reject();
            }}
            createOrder={(d, actions) => paypalCreateOrder({ ...payload, refund_policy_accepted: agreed.current })(d, actions)}
            onApprove={async (d, actions) => { const r = await paypalCapture(d, actions); if (r?.payment_status) onPaid(r); }}
            onCancel={paypalCancelled}
            onError={() => toast.error("PayPal payment could not be completed. Nothing was charged. Please try again.")}
          />
          {paypalMode !== "live" && <p className="-mt-1 text-center text-xs text-[#8A7F76]">PayPal sandbox · test payment only</p>}
        </div>
      )}
    </div>
  );
};
